import React from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';

export const TextHighlight = styled.span<{ isSelected: boolean; color?: string; bgColor?: string }>`
  margin-left: 2px;
  padding: 0 4px 0 4px;
  color: ${(props) => props.color ?? props.color};
  background-color: ${(props) => props.bgColor ?? props.bgColor};
  cursor: ${(props) => (props.isSelected ? 'default' : `pointer`)};
`;

const LinkHighlight = ({
  children,
  isSelected = false,
  color = '#C4C4C4',
  bgColor = '#636769',
}) => {
  return (
    <TextHighlight isSelected={isSelected} color={color} bgColor={bgColor}>
      {children}
    </TextHighlight>
  );
};

export default forwardRef(LinkHighlight);
